enum APP_ACTIONS {
  FETCH_USER = 'FETCH_USER',
}

export default APP_ACTIONS;
